<template lang="pug">
div(class="container-fluid" style="padding-top:20px;")
    .card
            .card-header.bg-menu.text-white
                .card-title Link's Habilitados
            .card-body
                .form-row.table-responsive 
                    .col-3.col-md-3.col-sm-12(v-if="ItemsLinks" v-for="item of ItemsLinks")
                        button.btn.btn-primary(@click="openLink(item.UrlLink)") {{item.NameLink}} 
                            .fa.fa-external-link
                        
            
</template>
<script>  
import Vue from 'vue'
import apiWeb from "../../api/apiSLC.js"
export default {
  
  data(){
      return{
             ItemsLinks :[],
             info:'',
      }
  },
  created(){
      var paramEnvio={IdUser: Vue.prototype.$info.idUser}
      this.info=Vue.prototype.$info.idUser
      apiWeb.post("LinkURL/LinkUrl_Active",paramEnvio).then(val=> this.ItemsLinks=JSON.parse(val.value));
  },
  methods: { 
      openLink: function(url)
      {
          window.open(url,'_blank ')
      }
    }
}
</script>
